import { createFileRoute } from '@tanstack/react-router'
import { ChartViewer } from 'pages/processData/ChartViewer'
import { processDataChartSearchSchema } from 'routes/process-data/-searchParams'

export const Route = createFileRoute('/process-data/chart/$chartID')({
  component: RouteComponent,
  validateSearch: processDataChartSearchSchema,
  staticData: {
    title: 'Process Data Chart',
    layout: {
      enableScrolling: true,
    },
  },
})

function RouteComponent() {
  const { chartID } = Route.useParams()
  const { orgId, siteId, alertId, sensorIds, start, end } = Route.useSearch()

  return (
    <ChartViewer
      orgId={orgId}
      siteId={siteId}
      chartId={chartID}
      alertId={alertId}
      sensorIdsParam={sensorIds}
      start={start}
      end={end}
    />
  )
}
